// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bbdf6394","239":"26fcd827","455":"9088bb10","488":"d35adadf"}[chunkId] + ".chunk.js";
};